// Per-environment build configuration, resolved once at import time.
//
// Every value that differs between dev / stage / prod but is NOT a secret lives
// in environments.json, checked in and reviewable in the diff. The deploy
// workflows pass exactly one variable — REACT_APP_ENV — and this module picks
// the matching entry, so a deploy and its rollback cannot drift apart.
//
// Deploy-only values (S3 bucket, CloudFront distribution, the URL the deploy
// verifies against) live in .github/environments.json instead, so they never
// reach the public bundle.
//
// Local dev: individual REACT_APP_* overrides still win (see ./index.js) — the
// compose stack points the app at container hostnames that no static manifest
// could describe.
import environments from "./environments.json";
import { ENV_NAME } from "./env";

const FALLBACK_ENV_NAME = "local";

export const envName = ENV_NAME || FALLBACK_ENV_NAME;

const resolved = environments[envName];

if (!resolved) {
  // eslint-disable-next-line no-console
  console.error(
    `Unknown REACT_APP_ENV "${envName}" — falling back to "${FALLBACK_ENV_NAME}". ` +
      `Valid values: ${Object.keys(environments).join(", ")}`
  );
}

// Falling back to "local" (not prod) is deliberate: a misconfigured build must
// fail loudly against localhost, never silently talk to the production API.
const environment = resolved || environments[FALLBACK_ENV_NAME];

export default environment;
